import script from "./cashbackHistoryCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashbackHistoryCard.vue?vue&type=script&lang=ts&setup=true"

import "./cashbackHistoryCard.vue?vue&type=style&index=0&id=7770738e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7770738e"]])

export default __exports__